<template>
    <div>
        <b-table
            :items="dataIdentitas"
            :fields="fields"
            bordered
            responsive
        >
            <template #cell(fotoIdentitas)="{ item }">
                <b-button
                    size="sm"
                    variant="pgiBtn"
                    name="bayarBtn"
                    @click="openPreview(item.fotoIdentitas)"
                >
                    <i class="fa fa-picture-o" aria-hidden="true"></i>
                </b-button>
            </template>
        </b-table>

        <ModalPreview
            modalId="modal-preview"
            :fotoPreview="activeFotoPreview"
        />
    </div>
</template>

<script>
import ModalPreview from '@/components/webcam/ModalPreview'

export default {
    name: 'DetailDataIdentitas',
    components: {
        ModalPreview
    },
    props: {
        dataIdentitas: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeFotoPreview: '',
            fields: [
                { key: 'jenisIdentitas', label: 'Jenis Identitas' },
                { key: 'noIdentitas', label: 'No Identitas' },
                { key: 'fotoIdentitas', label: 'Foto' }
            ]
        }
    },
    methods: {
        openPreview(foto) {
            this.activeFotoPreview = foto
            this.$bvModal.show('modal-preview')
        }
    }
}
</script>